import { useSelector } from 'react-redux';

import { useInstanceConfigs } from '~/data/instanceConfig';
import { StoreState } from '~/reducer';
import { appearanceStateSelector } from '~/selectors';
import { AppModules } from '~/services/Permissions';

import { AppearanceIncoming } from './types';

export const defaultAppearance: AppearanceIncoming = {
  fGreetingTranslations: [],
  fAppearanceBackground: '',
  fShowAnnouncement: false,
  fLeftSideMenuColors: {
    fIconsColor: '',
    fBackgroundColor: '',
  },
  fTopBarColors: {
    fIconsColor: '',
    fBackgroundColor: '',
  },
};

export const useAppearance = (): {
  customAppearance: AppearanceIncoming;
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
  isEnabled: boolean;
} => {
  const appearanceState = useSelector((state: StoreState) =>
    appearanceStateSelector(state),
  );
  const { isModuleEnabled } = useInstanceConfigs();

  const defaultAppearanceState = {
    customAppearance: defaultAppearance,
    isLoading: false,
    failedToLoad: false,
    hasData: true,
    isEnabled: false,
  };

  if (isModuleEnabled(AppModules.BRANDING)) {
    return appearanceState.failedToLoad
      ? defaultAppearanceState
      : { ...appearanceState, isEnabled: true };
  }

  return defaultAppearanceState;
};
